import { returnsDefaultWeightByCountrySchema } from "@redotech/redo-fulfillment-rate-table-common/rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Shared output of the country rate card RPCs: the full refreshed list. */
export const countryRateTableEntriesOutput = z.object({
  rateTables: z.array(
    z.object({
      id: zExt.objectId(),
      rateTable: returnsDefaultWeightByCountrySchema,
    }),
  ),
});
